import axios from '../../app/api/axios';
import {GET_SIDEBAR_CONTENT, SIDEBAR_CONTENT_LOADING, GET_PAGE_CONTENT, PAGE_CONTENT_LOADING} from './types';
import {GET_ERRORS} from '../Errors/types';

export const getSidebarContent = (slug) => dispatch => {
    dispatch(setSidebarContentLoading());

    axios
        .get('agep/v1/content/sidebar/' + slug)
        .then(res =>
            dispatch({
                type: GET_SIDEBAR_CONTENT,
                payload: res.data,
                slug: slug,
            })
        )
        .catch(function (err) {
            dispatch({
                type: GET_SIDEBAR_CONTENT,
                payload: null,
                slug: slug,
            });
            dispatch({
                type: GET_ERRORS,
                payload: {
                    status: (err.response.hasOwnProperty('status')) ? err.response.status : null
                }
            });
        });
};

export const setSidebarContentLoading = () => {
    return {
        type: SIDEBAR_CONTENT_LOADING
    };
};

export const getPageContent = (slug) => dispatch => {
    dispatch(setPageContentLoading());

    axios
        .get('agep/v1/content/page/' + slug)
        .then(res =>
            dispatch({
                type: GET_PAGE_CONTENT,
                payload: res.data,
                slug: slug,
            })
        )
        .catch(function (err) {
            let redirect = '';

            if (err.response.status === 303 && err.response.data.hasOwnProperty('redirect')) {
                redirect = err.response.data.redirect;
            }

            dispatch({
                type: GET_PAGE_CONTENT,
                payload: null,
                slug: slug,
            });
            dispatch({
                type: GET_ERRORS,
                payload: {
                    status: (err.response.hasOwnProperty('status')) ? err.response.status : null,
                    redirect: redirect,
                }
            });
        });
};

export const setPageContentLoading = () => {
    return {
        type: PAGE_CONTENT_LOADING
    };
};



// WEBPACK FOOTER //
// ./src/features/Content/actions.js